import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Stack,
  Link,
  Button,
  Heading,
  Text,
  useColorModeValue,
  Avatar,
  chakra,
} from "@chakra-ui/react";
import { Link as ReachLink } from "react-router-dom";

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { RootStore } from "../../../redux/Store";
import { GoogleLogin } from "react-google-login";
import {
  userGoogleLogin,
  userLogin,
} from "../../../redux/actions/user/UserActions";
import Oath from "../Utils/Oath";

export default function Login() {
  const [passwordVisibility, setPasswordVisibility] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorsMsg, setErrorsMsg] = useState<errorFields>({
    emailErr: "",
    passwordErr: "",
  });

  //---------------------------------Api integration----------------------------------------
  const dispatch = useDispatch();
  const userState = useSelector((state: RootStore) => state.user);
  const history = useHistory();
  const handleLogin = (e: any) => {
    e.preventDefault();
    if (validation()) {
      setErrorsMsg({ emailErr: "", passwordErr: "" });
      const userData = {
        email: email,
        password: password,
      };
      dispatch(userLogin(userData));
    }
  };
  //-----------------------------------Form validation--------------------------------------
  const validation = (): boolean => {
    let isValid = true;

    if (!email || !password) {
      if (!email && !password) {
        setErrorsMsg({
          emailErr: "Email field must not be empty",
          passwordErr: "Password field must not be empty",
        });
        isValid = false;
      } else if (!password) {
        setErrorsMsg({
          emailErr: "",
          passwordErr: "Password field must not be empty",
        });
        isValid = false;
      } else if (!email) {
        setErrorsMsg({
          emailErr: "Email field must not be empty",
          passwordErr: "",
        });
        isValid = false;
      }
    }
    if (email) {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(email) && !password) {
        setErrorsMsg({
          emailErr: "Please enter valid email address",
          passwordErr: "Password field must not be empty",
        });
        isValid = false;
      } else if (!pattern.test(email)) {
        setErrorsMsg({
          emailErr: "Please enter valid email address",
          passwordErr: "",
        });
        isValid = false;
      }
    }

    return isValid;
  };
  //------------------ Google login
  function responseSuccessGoogle(response: any) {
    dispatch(userGoogleLogin(response.tokenId));
  }
  function responseFailureGoogle() {
    console.log("error aayo bro");
  }

  return (
    <>
      <Flex align={"center"} justify={"center"}>
        <Stack
          spacing={8}
          mx={"auto"}
          maxW={"lg"}
          py={12}
          px={6}
          align="center"
          // background="red"
        >
          <Stack align={"center"}>
            <Avatar bg="dodgerblue" size="lg" />
            <Heading fontSize={"4xl"} textAlign="center">
              Login to your account
            </Heading>
            {/* <Text fontSize={"lg"} color={"gray.600"}>
              to get started with our features ✌️
            </Text> */}
          </Stack>
          <Box
            rounded={"md"}
            boxSize="inherit"
            bg={useColorModeValue("gray.50", "gray.800")}
            boxShadow={"md"}
            height="fit-content"
            textAlign="center"
            p={8}
          >
            <Stack spacing={2}>
              {/* <chakra.form> */}
              <FormControl id="Email" isRequired>
                <FormLabel>Email address</FormLabel>
                <Input
                  isInvalid={!errorsMsg.emailErr ? false : true}
                  type="email"
                  background="white"
                  id="email"
                  onChange={(event) => setEmail(event.target.value)}
                />
                {errorsMsg.emailErr && (
                  <Text fontSize="xs" color="red" marginTop="3px">
                    {errorsMsg.emailErr}
                  </Text>
                )}
              </FormControl>
              <FormControl id="Password" isRequired>
                <FormLabel>Password</FormLabel>
                <Input
                  isInvalid={!errorsMsg.passwordErr ? false : true}
                  type={passwordVisibility ? "password" : "text"}
                  background="white"
                  onChange={(event) => setPassword(event.target.value)}
                  id="password"
                />
                {errorsMsg.passwordErr && (
                  <Text fontSize="xs" color="red" marginTop="3px">
                    {errorsMsg.passwordErr}
                  </Text>
                )}
              </FormControl>
              <Stack spacing={4}>
                <Stack
                  direction={{ base: "column", sm: "row" }}
                  align={"start"}
                  justify={"space-between"}
                >
                  <Checkbox
                    onChange={() => setPasswordVisibility(!passwordVisibility)}
                  >
                    Show Password
                  </Checkbox>
                </Stack>
                {userState.loginSignUpData?.message && (
                  <Text fontSize="xs" color="red" marginTop="3px">
                    {userState.loginSignUpData?.message}
                  </Text>
                )}
                <Button
                  bg={"blue.400"}
                  color={"white"}
                  id="loginButton"
                  _hover={{
                    bg: "blue.500",
                  }}
                  onClick={handleLogin}
                >
                  Login
                </Button>
                <Link
                  color={"red"}
                  as={ReachLink}
                  _focus={{
                    outline: "none",
                    boxShadow: "none",
                    textDecor: "none",
                  }}
                  to="/user-forgot-password"
                >
                  Forgot password?
                </Link>
              </Stack>
              {/* </chakra.form> */}
            </Stack>
            <Text marginBlock="3">
              Don't have an account ☞{" "}
              <Link
                color={"blue.400"}
                as={ReachLink}
                to="/user-register"
                _focus={{
                  outline: "none",
                  boxShadow: "none",
                  textDecor: "none",
                }}
              >
                Click to Register
              </Link>
            </Text>
            <Text fontSize={"md"} color="#1E1F29" marginBlock="3">
              OR
            </Text>
            <GoogleLogin
              clientId={Oath}
              buttonText="Continue With Google"
              onSuccess={responseSuccessGoogle}
              onFailure={responseFailureGoogle}
              cookiePolicy={"single_host_origin"}
              redirectUri="https://good-regime.netlify.app"
              // className="btn btn-primary btn-block py-2"
            />
          </Box>
        </Stack>
      </Flex>
    </>
  );
}
